import { ICategoryProfile } from '@apiHooks/useCategoryProfile';
import { includesInLC } from '@helpers';

export type NamedCategoryProfile = { id: number; name: string };

// Entries without an id or a name can't be rendered or linked to, so they are dropped at the boundary.
function isNamedProfile(profile: ICategoryProfile): profile is NamedCategoryProfile {
    return typeof profile.id === 'number'
        && typeof profile.name === 'string'
        && profile.name.trim() !== '';
}

export function getSortedProfiles(profiles: ICategoryProfile[]): NamedCategoryProfile[] {
    return profiles
        .filter(isNamedProfile)
        .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
}

export function filterProfiles(profiles: NamedCategoryProfile[], search: string): NamedCategoryProfile[] {
    const query = search.trim();
    if (!query) return profiles;
    return profiles.filter(({ name }) => includesInLC(name, query));
}
